<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente icono-titulo="fas fa-plus" texto-titulo="Nueva Obra Social" />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Datos:</h5>
                  <form @submit.prevent="guardarObraSocial()">
                    <float-label label="Código:" clase>
                      <input
                        v-model="obraSocial.codigo"
                        id="codigo"
                        placeholder="Ingresar un código..."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.obraSocial.codigo.required ? 'is-invalid' : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.obraSocial.codigo.required"
                        >
                          Debe ingresar un código
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Codigo AFIP:" clase>
                      <input
                        v-model="obraSocial.codigo_afip"
                        id="codigo_afip"
                        placeholder="Ingresar nomenclatura de AFIP."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.obraSocial.codigo_afip.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="enviado && !$v.obraSocial.codigo_afip.required"
                        >
                          Debe ingresar un código
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Descripción:" clase="">
                      <input
                        id="descripcion"
                        v-model="obraSocial.descripcion"
                        placeholder="Ingresar una descripción..."
                        type="text"
                        class="form-control"
                      />
                    </float-label>
                    <button class="mt-1 btn btn-info float-right">Guardar</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import { required } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import ObraSocial from "@/models/obraSocial";
import axios from "axios";
export default {
  name: "NuevaObraSocial",
  components: {
    TituloComponente,
    FloatLabel,
  },
  validations: {
    obraSocial: {
      codigo_afip: { required },
      codigo: { required },
      descripcion: { required },
    },
  },
  data() {
    return {
      obraSocial: new ObraSocial(null, "", "", ""),
    };
  },
  methods: {
    guardarObraSocial() {
      axios
        .post("/obrasocial", this.obraSocial)
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ name: "ListarObraSocial" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
